import { create } from 'zustand/index';
import { persist } from 'zustand/middleware';

interface StoreState {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  isChildOpen: {
    key: string;
    value: boolean;
  };
  setIsChildOpen: (state: { key: string; value: boolean }) => void;
}

export const useSidebarStore = create<StoreState>()(
  persist(
    (set) => ({
      collapsed: false,
      setCollapsed: (collapsed) => set({ collapsed }),
      isChildOpen: {
        key: '',
        value: false,
      },
      setIsChildOpen: (isChildOpen) => set({ isChildOpen }),
    }),
    {
      name: 'sidebar-store',
      partialize: (state) => ({ collapsed: state.collapsed }),
    },
  ),
);
